export enum AgreementEnumType {
  PersonalDataConsent = "PersonalDataConsent",
  CommercialElectronicMessageConsent = "CommercialElectronicMessageConsent",
  ExplicitConsentText = "ExplicitConsentText",
  PartnershipAgreement = "PartnershipAgreement",
}

export const agreementTypeNameMapping: Record<string, AgreementEnumType> = {
  KVKK: AgreementEnumType.PersonalDataConsent,
  "Ticari Elektronik İleti İzni": AgreementEnumType.CommercialElectronicMessageConsent,
  "Açık Rıza Metni": AgreementEnumType.ExplicitConsentText,
  "İş Ortaklığı Sözleşmesi": AgreementEnumType.PartnershipAgreement,
};

export const agreementTypeOptions = Object.values(AgreementEnumType).map((type) => ({
  label: type,
  value: type,
}));

export const getAgreementTypeByName = (name?: string): AgreementEnumType | undefined => {
  if (!name) return undefined;
  const trimmedName = name.trim();
  const normalizedSpacing = trimmedName.replace(/\s+/g, " ");
  return agreementTypeNameMapping[trimmedName] || agreementTypeNameMapping[normalizedSpacing];
};
